import { formList } from '@mantine/form';
import {
  BusinessBankAccountDepositTypes,
  BusinessBankAccountTypes,
} from '../enums/bank.enums';
import { BusinessTypes } from '../enums/business-type';
import { Currency } from '../enums/retrieve-transaction.enums';
import { MerchantOnboardingFormValues } from '../type/merchant-onboarding-form-values.types';

export const defaultSettlementValue = {
  accountDepositTypeId: BusinessBankAccountDepositTypes.BANK,
  accountTypeId: BusinessBankAccountTypes.SAVINGS,
  bankName: '',
  accountName: '',
  accountNumber: '',
  currencyId: undefined,
};

export const OnboardFormInitialValues: MerchantOnboardingFormValues = {
  businessTypeId: BusinessTypes.STARTER,

  merchantName: '',
  merchantBusinessName: '',
  businessHandle: '',
  merchantCompanyTin: '',

  mainOfficeContactNumber: '',
  mainOfficeBldgNameNo: '',
  mainOfficeStreetAddress: '',
  mainOfficeBarangay: '',
  mainOfficeCity: '',
  mainOfficeProvince: '',
  mainOfficePostalCode: '',

  isBrickAndMortarStore: true,
  industry: '',
  serviceDescription: '',
  modeOfPayment: [],
  currency: Currency.PHP,
  aubPartnerId: '',
  estimatedMonthlyGrossTransaction: '',

  businessWebsiteUrl: '',
  facebookUrl: '',
  twitterUrl: '',
  instagramUrl: '',
  tiktokUrl: '',
  isBusinessWebsiteUnderDevelopment: false,

  aFirstName: '',
  aMiddleName: '',
  isAMNameDisabled: false,
  aLastName: '',
  aPosition: '',
  aEmailAddress: '',
  aContactNumber: '',
  aDateOfBirth: null,
  aMothersMaidenName: '',
  aGender: undefined,
  aAubNationalityCode: '',
  aAubDeviceId: '',
  aAubIdCode: '',
  aAubIdNumber: '',
  aAubRegionCode: '',

  settlements: formList([defaultSettlementValue]),

  isWantPackworksWallet: true,
  isWantPayMayaBankWallet: true,
  isWantPayMayaBankAccount: true,

  idsOfValidSignatories: formList([]),
  idsOfValidSignatoriesBack: formList([]),
  idsOfValidSignatoriesSignature: formList([]),

  barangayBusinessPermit: formList([]),
  barangayBusinessPermitBack: formList([]),
  barangayBusinessPermitSignature: formList([]),

  storePhoto: formList([]),

  mayorsOrBusinessPermit: formList([]),
  mayorsOrBusinessPermitBack: formList([]),
  mayorsOrBusinessPermitSignature: formList([]),

  birCert2303: formList([]),
  birCert2303Back: formList([]),
  birCert2303Signature: formList([]),

  secCert: formList([]),
  secCertBack: formList([]),
  secCertSignature: formList([]),

  aoiAndByLaws: formList([]),
  aoiAndByLawsBack: formList([]),
  aoiAndByLawsSignature: formList([]),

  gis: formList([]),
  gisBack: formList([]),
  gisSignature: formList([]),

  secretarysCert: formList([]),
  secretarysCertBack: formList([]),
  secretarysCertSignature: formList([]),

  agreeTermsPrivacy: false,
  // bldgNameNo: "",
};

export const UpdateOnboardFormInitialValues = {
  businessTypeId: BusinessTypes.STARTER,

  merchantName: '',
  merchantBusinessName: '',
  businessHandle: '',
  merchantCompanyTin: '',

  mainOfficeContactNumber: '',
  mainOfficeBldgNameNo: '',
  mainOfficeStreetAddress: '',
  mainOfficeBarangay: '',
  mainOfficeCity: '',
  mainOfficeProvince: '',
  mainOfficePostalCode: '',

  registeredContactNumber: '',
  registeredBldgNameNo: '',
  registeredStreetAddress: '',
  registeredBarangay: '',
  registeredCity: '',
  registeredProvince: '',
  registeredPostalCode: '',

  isBrickAndMortarStore: true,
  industry: '',
  serviceDescription: '',
  modeOfPayment: [],
  currency: Currency.PHP,
  aubPartnerId: '',
  estimatedMonthlyGrossTransaction: '',
  acquirers: [],

  businessWebsiteUrl: '',
  facebookUrl: '',
  twitterUrl: '',
  instagramUrl: '',
  tiktokUrl: '',
  isBusinessWebsiteUnderDevelopment: false,

  incorporators: formList([
    {
      firstName: '',
      middleName: '',
      hasMiddleName: true,
      lastName: '',
      bldgNameNo: '',
      emailAddress: '',
      contactNumber: '',
      birthDate: null,
      residentialAddress: '',
      barangay: '',
      city: '',
      province: '',
      postalCode: '',
    },
    {
      firstName: '',
      middleName: '',
      hasMiddleName: true,
      lastName: '',
      bldgNameNo: '',
      emailAddress: '',
      contactNumber: '',
      birthDate: null,
      residentialAddress: '',
      barangay: '',
      city: '',
      province: '',
      postalCode: '',
    },
    {
      firstName: '',
      middleName: '',
      hasMiddleName: true,
      lastName: '',
      bldgNameNo: '',
      emailAddress: '',
      contactNumber: '',
      birthDate: null,
      residentialAddress: '',
      barangay: '',
      city: '',
      province: '',
      postalCode: '',
    },
  ]),
  copyProToSignatory: false,
  signatories: formList([
    {
      firstName: '',
      middleName: '',
      hasMiddleName: true,
      lastName: '',
      position: '',
    },
  ]),

  copyProToRep: false,

  aFirstName: '',
  aMiddleName: '',
  isAMNameDisabled: false,
  aLastName: '',
  aPosition: '',
  aEmailAddress: '',
  aContactNumber: '',
  aDateOfBirth: null,
  aTin: '',
  aSss: '',
  aMothersMaidenName: '',
  aGender: undefined,
  aAubNationalityCode: '',
  aAubDeviceId: '',
  aAubIdCode: '',
  aAubIdNumber: '',
  aAubRegionCode: '',

  copyRepInfo: false,

  eFirstName: '',
  eMiddleName: '',
  isEMNameDisabled: false,
  eLastName: '',
  ePosition: '',
  eEmailAddress: '',
  eContactNumber: '',
  eDateOfBirth: null,
  eTin: '',
  eSss: '',

  settlements: formList([defaultSettlementValue]),

  isWantPackworksWallet: true,
  isWantPayMayaBankWallet: true,
  isWantPayMayaBankAccount: true,

  idsOfValidSignatories: formList([]),
  idsOfValidSignatoriesBack: formList([]),
  idsOfValidSignatoriesSignature: formList([]),

  barangayBusinessPermit: formList([]),
  barangayBusinessPermitBack: formList([]),
  barangayBusinessPermitSignature: formList([]),

  storePhoto: formList([]),

  mayorsOrBusinessPermit: formList([]),
  mayorsOrBusinessPermitBack: formList([]),
  mayorsOrBusinessPermitSignature: formList([]),

  birCert2303: formList([]),
  birCert2303Back: formList([]),
  birCert2303Signature: formList([]),

  secCert: formList([]),
  secCertBack: formList([]),
  secCertSignature: formList([]),

  aoiAndByLaws: formList([]),
  aoiAndByLawsBack: formList([]),
  aoiAndByLawsSignature: formList([]),

  gis: formList([]),
  gisBack: formList([]),
  gisSignature: formList([]),

  secretarysCert: formList([]),
  secretarysCertBack: formList([]),
  secretarysCertSignature: formList([]),

  agreeTermsPrivacy: false,
  // bldgNameNo: "",
};
